import { useCallback, useState } from 'react';
import { onboardingService } from '@/features/onboarding/services/onboardingService';
import { useSpinner, useToast } from '@chikara/ui';
import { t } from '@/i18n';


export const useValidateCustomerId = () => {
    const { show, hide, isSpinnerLoading } = useSpinner();
    const toast = useToast();
    const [error, setError] = useState<string | null>(null);

    const validateCustomerId = useCallback(async (customerId: string): Promise<string | null> => {
        const trimmed = customerId.trim();
        if (!trimmed) return null;

        show();
        setError(null);
        try {
            const response = await onboardingService.validateCustomerId({ customer_id: trimmed });
            // BFF envelope: { response, data: { data: { customer_id, status }, response }, meta }
            const upstream = response?.data?.data;
            if (upstream?.status === 'enabled') {
                return upstream.customer_id ?? trimmed;
            }
            const message = t('onboarding.companyInfo.errors.invalid');
            setError(message);
            toast.error(message);
            return null;
        } catch (err) {
            // Endpoint is in SILENT_ERROR_ENDPOINTS — we own the user-facing message.
            const message = t('onboarding.companyInfo.errors.generic');
            setError(message);
            toast.error(message);
            return null;
        } finally {
            hide();
        }
    }, [show, hide, toast]);

    return {
        validateCustomerId,
        isLoading: isSpinnerLoading,
        error,
        clearError: () => setError(null),
    };
};
